import styled from 'styled-components';

export const Main = styled.div`
  @page {
    margin: 0mm;
    padding: 0mm;
  }
`;

export const DevMode = styled(Main)`
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background-color: ${({ theme }) => theme.neutral_200};
  z-index: 10;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.primary_300};
  text-decoration: underline;
  cursor: pointer;
`;
